import React from "react";
import {
    Note,
    Tone
} from "../../model/core";
import { produceScaleNoteNames } from "../../model/noteNaming";
import { RydFretboard } from "../widgets/RydFretboard";
import { RydCollapsableCard } from "../widgets/RydCollapsableCard";
import { getToneColorBaseClassName } from "../../render/renderUtils";
import './RydScaleInfobox.css';
import { RydIOKeybed } from "../rolls/PianoKeybed";
import { Tonality } from "../../model/scales";


export const isToneCenter = (n: Note, root?: Tone) => n.getTone().index === root?.index
    ? ['piano-roll--tonality--center']
    : [];
const isInTonality = (n: Note, tonality?: Tonality) => {
    if (!tonality) return [];
    const isInTonality = tonality.containsNote(n);
    return isInTonality ? ["piano-roll--tonality-note"] : ["piano-roll--non-tonality-note"];
}

export function RydScaleInfobox({
    tonality
}: {
    tonality: Tonality
}) {
    return (<>
        <div>Scale: {tonality.center.getName()} - {tonality.scalePattern.name}</div>
        <RydCollapsableCard title="Notes" >
            {produceScaleNoteNames(tonality).map((n, i) => <span key={i}>{n} </span>)}
        </RydCollapsableCard>
        <RydCollapsableCard title="Piano" >
            <RydIOKeybed
                stylingSource={(note: Note) => [
                    // (n) => [getToneColorBaseClassName(n.getTone())],
                    (n) => isToneCenter(n, tonality.center),
                    (n) => isInTonality(n, tonality),
                ]
                    .map((f) => f(note))
                    .flat()} />
        </RydCollapsableCard>
        <RydCollapsableCard title="Fretboard" >
            <RydFretboard config={{
                numberOfStrings: 6,
                numberOfFrets: 24,
                tuning: "E4, A4, D5, G5, B5, E6".split(',').map(note => Note.fromName(note.trim()).index)
            }}
                stylingSource={(note: Note) => {
                    return [
                        (n) => tonality.containsNote(n)
                            ? [getToneColorBaseClassName(n.getTone()), 'fretboard--cell--tonality-note']
                            : ['note-disabled'],
                        (n) => tonality.center.index === n.getTone().index
                            ? ['fretboard--cell--tonality-center']
                            : [],
                    ].map((f) => f(note)).flat();
                }}
            />
        </RydCollapsableCard>
    </>);
}
